import classNames from 'classnames/bind';
import styles from './TipsPage.module.scss';
import TipCards from '~/Layouts/components/TipCards';
import { filterTips } from '~/helper/help';
import { useContext, useEffect, useRef, useState } from 'react';
import { FetchDataContext } from '~/component/Context/FetchDataProvider';
import { scrollToTop2 } from '~/helper/scroll';
import useMeta from '~/hooks/useMeta';

const cx = classNames.bind(styles);

function TipsPage() {
  const { tips, tipsType, loadTips } = useContext(FetchDataContext);
  const [typeShow, setTypeShow] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');
  const tipRef = useRef();
  useEffect(() => {
    loadTips();
    scrollToTop2(tipRef);
  }, []);

  useEffect(() => {
    setTypeShow(tipsType);
  }, [tips]);

  const handleCateClick = (type) => {
    setActiveCategory(type);
    if (type === 'all') {
      setTypeShow(tipsType);
    } else {
      setTypeShow([type]);
    }
  };

  useMeta({
    title: 'Tips Blog - Ngô Gia Quyến | Hướng dẫn lập trình và công nghệ',
    description: 'Khám phá các bài viết về lập trình web, từ CSS, HTML, JavaScript đến PHP và ReactJS. Tìm hiểu cách tối ưu hóa và triển khai dự án vào thực tế.',
    keywords: 'lập trình, CSS, HTML, JavaScript, PHP, ReactJS, hướng dẫn, tips, deploy, tutorial',
    author: 'Ngô Gia Quyến',
    url: 'https://ngogiaquyen.id.vn/tips-page',
  });

  return (
    <div className={cx('wrapper')} ref={tipRef}>
      <div className={cx('header')}>
        <h1 className={cx('title')}>Tips Blog</h1>
      </div>

      {/* Search Bar */}
      {/* <div className={cx('search-bar')}>
        <FontAwesomeIcon className={cx('search-icon')} icon={faSearch} />
        <input type="text" placeholder="Tìm kiếm bài viết..." className={cx('search-input')} />
      </div> */}

      {/* Categories */}
      <div className={cx('categories')}>
        <button 
          className={cx({ active: activeCategory === 'all' })}
          onClick={() => handleCateClick('all')}
        >
          <span>Tất cả</span>
        </button>
        {tipsType.map((type) => (
          <button 
            key={type.name}
            className={cx({ active: activeCategory === type })}
            onClick={() => handleCateClick(type)}
          >
            <span>{type.name}</span>
          </button>
        ))}
      </div>
      <div className={cx('tips')}>
        {typeShow.map((type, index) => (
          <div className={cx('tip-card')} key={index}>
            <TipCards type={type.name} data={filterTips(type.name, tips)} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default TipsPage;
